


// used in Person Detail view ( /details )
export class Link {
    href: string;
}

export class Links {
    self?: Link;
    previous?: Link;
    next?: Link;
}

export class Address {
    street_address?: string;
    locality?: string;
    region?: string;
    postal_code?: string;
    country?: string;

    getChangedData(person : PersonDetails) {
        let returnValue = '\"address\":{';
        if(person.address != undefined){
            if (this.street_address != null && this.street_address.trim() != person.address.street_address) {
                returnValue += '\"street_address\": ' + '\"' + this.street_address.trim() + '\",';
            }
            if (this.locality != null && this.locality.trim() != person.address.locality) {
                returnValue += '\"locality\": ' + '\"' + this.locality.trim() + '\",';
            } if (this.region != null && this.region.trim() != person.address.region) {
                returnValue += '\"region\": ' + '\"' + this.region.trim() + '\",';
            } if (this.postal_code != null && this.postal_code.trim() != person.address.postal_code) {
                returnValue += '\"postal_code\": ' + '\"' + this.postal_code.trim() + '\",';
            } if (this.country != null && this.country.trim() != person.address.country) {
                returnValue += '\"country\": ' + '\"' + this.country.trim() + '\",';
            }
        }
        else{
            if (this.street_address != null) {
                returnValue += '\"street_address\": ' + '\"' + this.street_address.trim() + '\",';
            }
            if (this.locality != null) {
                returnValue += '\"locality\": ' + '\"' + this.locality.trim() + '\",';
            } if (this.region != null) {
                returnValue += '\"region\": ' + '\"' + this.region.trim() + '\",';
            } if (this.postal_code != null) {
                returnValue += '\"postal_code\": ' + '\"' + this.postal_code.trim() + '\",';
            } if (this.country != null) {
                returnValue += '\"country\": ' + '\"' + this.country.trim() + '\",';
            }
        }
        if (returnValue === '\"address\":{') {
            return '';
        }
        if (!returnValue.endsWith('\":{')) {
            returnValue = returnValue.substring(0, returnValue.length - 1);
        }
        returnValue += '},';
        return returnValue;
    }

}

//Combining profile and kyc details
export class Userdetails
{
    PersonDetails?: PersonDetails={};
    KycDetails?: KycDetails={};
}

// Person Detail view ( /details )
export class PersonDetails {
    sub?: string;
    name?: string;
    given_name?: string;
    family_name?: string;
    middle_name?: string;
    preferred_username?: string;
    nickname?: string;
    profile?: string;
    picture?: string;
    website?: string;
    email?: string;
    email_verified?: boolean;
    gender?: string;
    birthdate?: string;
    birthplace?: string;
    zoneinfo?: string;
    locale?: string;
    phone_number?: string;
    phone_number_verified?: boolean;
    is_blocked?: boolean;
    date_of_account_creation?: string;
    updated_at?: string;
    status?: string;
    market?: string;
    address?: Address;
    links?: Links;
    username?: string;
    citaccess?: boolean;
    locked_until?: string;
    created_date?:string;
    modified_date?:string;
    last_password_update?: string;
    recovery_emails?: Array<{
        created?: string;
        updated?: string;
        verified?: boolean;
        email?: string;
        last_verification_timestamp?: string;
    }>;
    recovery_phone_numbers?: Array<{
        created?: string;
        updated?: string;
        verified?: boolean;
        phone_number?: string;
        last_verification_timestamp?: string;
    }>;
};

export class PersonDetailsUpdate {
    name?: string;
    given_name?: string;
    family_name?: string;
    middle_name?: string;
    preferred_username?: string;
    nickname?: string;
    gender?: string;
    birthdate?: string;
    birthplace?: string;
    address?: Address;
    username?: string;
    status?: string;
    citaccess?: boolean;
    locked_until?:string;
    

    getChangedData(person : PersonDetails) {

        let returnValue = '{\"user_details\":{';
        let birthdate = ((this.birthdate == null || this.birthdate == "") && person.birthdate == null)? false : true;
        if (this.given_name != null && this.given_name.trim() != person.given_name) {
            returnValue += '\"given_name\": ' + '\"' + this.given_name.trim() + '\",';
        } if (this.middle_name != null && this.middle_name.trim() != person.middle_name) {
            returnValue += '\"middle_name\": ' + '\"' + this.middle_name.trim() + '\",';
        } if (this.family_name != null && this.family_name.trim() != person.family_name) {
            returnValue += '\"family_name\": ' + '\"' + this.family_name.trim() + '\",';
        } if (this.preferred_username != null && this.preferred_username.trim() != person.preferred_username) {
            returnValue += '\"preferred_username\": ' + '\"' + this.preferred_username.trim() + '\",';
        } if (this.nickname != null && this.nickname.trim() != person.nickname) {
            returnValue += '\"nickname\": ' + '\"' + this.nickname.trim() + '\",';
        } if (this.gender != null && this.gender.trim() != person.gender) {
            returnValue += '\"gender\": ' + '\"' + this.gender.trim() + '\",';
        } if (birthdate && this.birthdate.trim() != person.birthdate) {
            returnValue += '\"birthdate\": ' + '\"' + this.birthdate.trim() + '\",';
        } if (this.birthplace != null && this.birthplace.trim() != person.birthplace) {
            returnValue += '\"birthplace\": ' + '\"' + this.birthplace.trim() + '\",';
        }
        returnValue += this.address.getChangedData(person);
        if (!returnValue.endsWith('\":{')) {
            returnValue = returnValue.substring(0, returnValue.length - 1);
        }
        returnValue += '} }';
        return returnValue;
    }

    getChangedDataRo(person : PersonDetails){
        let returnValue = '{';
        if (this.status != null && this.status.trim() != person.status) {
            returnValue += '\"status\": ' + '\"' + this.status.trim() + '\",';
        }if (this.citaccess != null && this.citaccess != person.citaccess) {
            returnValue += '\"citAccess\": ' +   this.citaccess + '\,';
        }
       // changed if (!returnValue.endsWith('\":{')) {
        if (!returnValue.endsWith('{')) {
            returnValue = returnValue.substring(0, returnValue.length - 1);
        }

        returnValue += '}';
        return returnValue;
    }
    getChangedDataAl(person : PersonDetails){
        let returnValue = '{';
        if (this.status != null && this.status.trim() != person.status) {
            returnValue += '\"status\": ' + '\"' + this.status.trim() + '\",';
        }
       // changed if (!returnValue.endsWith('\":{')) {
        if (!returnValue.endsWith('{')) {
            returnValue = returnValue.substring(0, returnValue.length - 1);
        }

        returnValue += '}';
        return returnValue;
    }
    getChangedDataCz(person : PersonDetails){
        let returnValue = '{';
        if (this.status != null && this.status.trim() != person.status) {
            returnValue += '\"status\": ' + '\"' + this.status.trim() + '\",';
        }
       // changed if (!returnValue.endsWith('\":{')) {
        if (!returnValue.endsWith('{')) {
            returnValue = returnValue.substring(0, returnValue.length - 1);
        }

        returnValue += '}';
        return returnValue;
    }
    getChangedDataVo(person : PersonDetails){
        let returnValue = '{';
        if (this.status != null && this.status.trim() != person.status) {
            returnValue += '\"status\": ' + '\"' + this.status.trim() + '\",';
        }
       // changed if (!returnValue.endsWith('\":{')) {
        if (!returnValue.endsWith('{')) {
            returnValue = returnValue.substring(0, returnValue.length - 1);
        }
        if (this.locked_until != null && this.locked_until != person.locked_until) {
            returnValue += '\"locked_until\": "0"';
        }

        returnValue += '}';
        return returnValue;
    }
}

export function getUpdatePersonFromDetails(person: PersonDetails): PersonDetailsUpdate {
    const personUpdate = new PersonDetailsUpdate();
    // avoid calling undefined before data is copied
    personUpdate.address = new Address();
    personUpdate.given_name = person.given_name;
    personUpdate.family_name = person.family_name;
    personUpdate.middle_name = person.middle_name;
    personUpdate.preferred_username = person.preferred_username;
    personUpdate.nickname = person.nickname;
    personUpdate.gender = person.gender;
    personUpdate.status = person.status;
    personUpdate.citaccess = person.citaccess;
    personUpdate.locked_until = person.locked_until;
    personUpdate.birthdate = person.birthdate;
    personUpdate.birthplace = person.birthplace;
    if (person.address) {
        personUpdate.address.country = person.address.country;
        personUpdate.address.street_address = person.address.street_address;
        personUpdate.address.locality = person.address.locality;
        personUpdate.address.region = person.address.region;
        personUpdate.address.postal_code = person.address.postal_code;
    } else {
        personUpdate
            .address = new Address();
    }
    return personUpdate;
}

export class RemememberMeResult {
    links?: Links = {};
    offset?: number;
    count?: number;
    totalItems?: number;
    items?: RememberMeDetails[] = [];
}

export interface RememberMeDetails{
    seriesIdentifier: string;
    userAgent: string;
    creationTime: string;
    expirationTime: string;
}

export class LookUpResult {
    links?: Links = {};
    offset?: number;
    count?: number;
    status?: string;
    totalItems?: number;
    items?: SearchResult[] = [];
}

export interface RecoveryEmail {
    created: string;
    updated: string;
    verified: boolean;
    email: string;
    last_verification_timestamp: string;
}

export interface RecoveryPhoneNumber {
    created: string;
    updated: string;
    verified: boolean;
    phone_number: string;
    last_verification_timestamp: string;
}

export interface SearchResult {
    sub: string;
    given_name: string;
    family_name: string;
    middle_name: string;
    preferred_username: string;
    email: string;
    email_verified: boolean;
    birthdate: string;
    zoneinfo: string;
    locale: string;
    phone_number: string;
    phone_number_verified: boolean;
    is_blocked: string;
    date_of_account_creation: string;
    updated_at: string;
    market: string;
    status: string;
    recovery_emails?: RecoveryEmail[];
    recovery_phone_numbers?: RecoveryPhoneNumber[];
};




export class Scope {
    scopeId: string;
    description: string;
    icon: string;

}


// Consent App model
export class App {
    scopes: Scope[];
    nonGrantedScopes?: string[];
    links?: Object[];
    appId: string;
    name: string;
    description?: string;
    creationTime?: string;
    lastUpdateTime?: string;
    expirationTime?: string;
    status?: string;
    logo_uri?: string;
    tos_uri?: string;
    policy_uri?: string;
    valid_logo_uri?: boolean = false;
};

export interface AppListResponse {
    links?: Links;
    count?: number;
    totalItems?: number;
    offset?: number;
    items?: App[];
}


export interface KycDetails {
  status?: string;
  external_reference_id?: string;
  external_reference_link?: string;
  history?: History[];
  nationality?: string;
  fiscal_code?: string;
  personal_id?: PersonalId;
  last_updated?: string;
}

export interface Personalid {
  id_type?: string;
  id_number?: string;
  issue_date?: string;
  expiration_date?: string;
}

export interface History {
  status?: string;
  timestamp?: string;
  comment?: string;
}


export class KycUpdateData {
  status?: string;
  external_reference_id?: string;
  external_reference_link?: string;
  comment?: string;
  nationality?: string;
  fiscal_code?: string;
  personal_id?: PersonalId;

      getChangedData(kycData) {

        let returnValue = '{ \"kyc_details\" : {';
        if(kycData != undefined){
                let comment = ((this.comment == null || this.comment == "") && kycData.comment == null)? false : true;
                if (this.status != null && this.status != kycData.status) {
                    returnValue += ' \"status\" : ' + '\"' + this.status + '\",';
                }
                if (this.external_reference_id != null && this.external_reference_id.trim() != kycData.external_reference_id) {
                    returnValue += ' \"external_reference_id\" : ' + '\"' + this.external_reference_id.trim() + '\",';
                }
                if (this.external_reference_link !=null && this.external_reference_link.trim() != kycData.external_reference_link) {
                    returnValue += ' \"external_reference_link\" : ' + '\"' + this.external_reference_link.trim() + '\",';
                }
                if (comment && this.comment.trim() != kycData.comment) {
                    returnValue += ' \"comment\" : ' + '\"' + this.comment.trim() + '\",';
                }
                if (this.nationality != null && this.nationality.trim() != kycData.nationality) {
                    returnValue += ' \"nationality\" : ' + '\"' + this.nationality.trim() + '\",';
                }
                if (this.fiscal_code != null && this.fiscal_code.trim() != kycData.fiscal_code) {
                    returnValue += ' \"fiscal_code\" : ' + '\"' + this.fiscal_code.trim() + '\",';
                }
                if (this.personal_id) {
                    if(kycData.personal_id !== null && kycData.personal_id !== undefined){
                        returnValue += this.personal_id.getChangedData(kycData);
                    }else {
                        returnValue += this.personal_id.getChangedData1();
                    }
                }
                if (!returnValue.endsWith('\":{')) {
                    returnValue = returnValue.substring(0, returnValue.length - 1);
                }
        }
        returnValue += ' } }';
        return returnValue;
    }
}

export class PersonalId {
  id_type?: string;
  id_number?: string;
  issue_date?: string;
  id_country?: string;
  expiration_date?: string;
  getChangedData(kycData): string {
      let issue_date = ((this.issue_date == null || this.issue_date == "") && kycData.personal_id.issue_date == null)? false : true;
      let expiration_date = ((this.expiration_date == null || this.expiration_date == "") && kycData.personal_id.expiration_date == null)? false : true;
      let returnValue = '\"personal_id\":{';
         if (this.id_type != null && (this.id_type.trim() !== kycData.personal_id.id_type)) {
            returnValue += ' \"id_type\" : ' + '\"' + this.id_type.trim() + '\",';
        }
        if (this.id_number != null && (this.id_number.trim() !== kycData.personal_id.id_number)) {
            returnValue += ' \"id_number\" : ' + '\"' + this.id_number.trim() + '\",';
        }
        if (issue_date && (this.issue_date.trim() !== kycData.personal_id.issue_date)) {
            returnValue += ' \"issue_date\" : ' + '\"' + this.issue_date.trim() + '\",';
        }
        if (this.id_country != null && (this.id_country.trim() !== kycData.personal_id.id_country)) {
            returnValue += ' \"id_country\" : ' + '\"' + this.id_country.trim() + '\",';
        }
        if (expiration_date && (this.expiration_date.trim() !== kycData.personal_id.expiration_date)) {
            returnValue += ' \"expiration_date\" : ' + '\"' + this.expiration_date.trim() + '\",';
        }
        if (!returnValue.endsWith('\":{')) {
            returnValue = returnValue.substring(0, returnValue.length - 1);
        }
        returnValue += ' } ';
        return returnValue;
  }
  getChangedData1(): string {
      let returnValue = '\"personal_id\":{';
        if (this.id_type && this.id_type.length > 0) {
            returnValue += ' \"id_type\" : ' + '\"' + this.id_type + '\",';
        }
        if (this.id_number && this.id_number.length > 0) {
            returnValue += ' \"id_number\" : ' + '\"' + this.id_number + '\",';
        }
        if (this.issue_date && this.issue_date.length > 0) {
            returnValue += ' \"issue_date\" : ' + '\"' + this.issue_date + '\",';
        }
        if (this.id_country && this.id_country.length > 0) {
            returnValue += ' \"id_country\" : ' + '\"' + this.id_country + '\",';
        }
        if (this.expiration_date && this.expiration_date.length > 0) {
            returnValue += ' \"expiration_date\" : ' + '\"' + this.expiration_date + '\",';
        }
        if (!returnValue.endsWith('\":{')) {
            returnValue = returnValue.substring(0, returnValue.length - 1);
        }
        returnValue += ' } ';
        return returnValue;
  }
}




// WEBPACK FOOTER //
// ./src/app/_models/data.structures.ts